import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: "16px 12px",
    marginTop: "16px",
    marginBottom: "24px",
  },
  checkbox: {
    color: "#000",
    "&.MuiCheckbox-colorSecondary.Mui-checked": {
      color: "#000",
    },
  },
  menu: {
    "& .MuiList-padding": {
      padding: 10,
    },
    position: "relative",
  },
  menuArrow: {
    position: "absolute",
    top: 0,
    right: 10,
    width: 0,
    height: 0,
    borderLeft: "8px solid transparent",
    borderRight: "8px solid transparent",
    borderBottom: "8px solid white",
  },
  buttonsContainer: {
    marginTop: "20px",
  },
  chip: {
    marginLeft: "32px",
  },
  searchField: {
    width: "375px",
    border: "1px solid lightgray",
    paddingLeft: "10px",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    borderRadius: "4px",
    "&.MuiInput-underline:before": {
      border: "none",
    },
  },
}));
